export default "__VITE_ASSET__BvAb3vX9__"